import { render } from "./HeroiconsOutlineGlobe.vue?vue&type=template&id=a794e872"
const script = {}

import exportComponent from "E:\\Work\\wynajmy\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineGlobe.vue"]])

export default __exports__